<template>
	<section class="shadow-md py-16" :class="backgroundColor">
		<div class="full lg:w-4/5 mx-auto">
			<h2 class="text-4xl mb-4 text-center" :class="textColor">
				<slot name="title"></slot>
			</h2>	
			<slot></slot>
		</div>
	</section>
</template>

<script>
	export default {
		props: ['background'],
		data() {
			return {
			}
		},
		computed: {
			backgroundColor() {
				if (this.background == 'blue') return 'bg-gray-900';
				if (!this.background) return 'bg-white';
			},
			textColor() {
				if (this.background == 'blue') return 'text-white';
				if (!this.background) return 'text-gray-900';
			}
		}
	}
</script>
